import { Injectable } from "@angular/core";
import { ApicallService } from "@core-services/apicall.service";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { AssetsScrollService } from "@main-services/assets-scroll.service";
import { PaginatedEvent } from "@models/pagination_event";
import { CoreStoreFacade } from "@modules/+new/core/core-store/domain/+state/core-store.facade";

@Injectable()
export class AssetsTradeScrollService extends AssetsScrollService {
	// Flows that support infinite scrolling - add new flows here!
	protected readonly supported_flows: string[] = ["buy", "voucher", "contacts"];
	private activeFlow: string = "";

	public constructor(
		public apiCallService: ApicallService,
		protected tradableListService: TradableListService,
		protected readonly coreStoreFacade: CoreStoreFacade
	) {
		super(apiCallService, tradableListService, coreStoreFacade);
	}

	public getNewEvent(): PaginatedEvent {
		const event: PaginatedEvent = new PaginatedEvent();
		// For voucher any event that is used to fetch assets should already be limited to cryptocoin only!
		// ONCE all filtering is backend-side, we should rework this to be handed over from the specific flows
		if (this.activeFlow === "voucher" || this.activeFlow === "contacts") {
			event.setType(["cryptocoin"]);
		}
		return event;
	}

	public isInfiniteScrollSupported(flow: string): boolean {
		return this.supported_flows.includes(flow);
	}

	public setActiveFlow(activeFlow: string): void {
		this.activeFlow = activeFlow;
	}

	// Hard reset in case of api-error during data-fetching
	public refetchList(filters: string[] = [""]): void {
		this.resetList();
		this.resetError();
		this.filterUpdate(filters, "");
	}

	public fetchApiData(event: PaginatedEvent): void {
		// In case of error we dont want more calls go out unless the user manually requests a re-fetch
		if (this.getErrorValue()) {
			return;
		}
		super.fetchApiData(event);
	}
}
